import { createSlice } from "@reduxjs/toolkit";

const mfaSlice = createSlice({
  name: "mfa",
  initialState: {
    adminMfaApplied: false,
    loaded: false,
  },
  reducers: {
    setAdminMfaApplied: (state, action) => {
      state.adminMfaApplied = action.payload;
      state.loaded = true;
    },
    resetMfaState: (state) => {
      state.adminMfaApplied = false;
      state.loaded = false;
    },
  },
});

export const { setAdminMfaApplied, resetMfaState } = mfaSlice.actions;
export default mfaSlice.reducer;
